import React from "react"

export default function Home() {
  return <div>Welcome to the future home of my resume!</div>
}
